import React from 'react';
import DropdownContext from '../context/dropdownContext';

export default function useDropdown() {
    return React.useContext(DropdownContext);
}
